import {listRole} from "../../crud/role.crud";
import {put, takeLatest} from "redux-saga/effects";
export const actionTypes = {
    ROLE_ADDED: "ROLE_ADDED",
    ROLE_ADDED_SUCCESS: "ROLE_ADDED_SUCCESS",
    ROLE_UPDATED: "ROLE_UPDATED",
    ROLE_UPDATED_SUCCESS: "ROLE_UPDATED_SUCCESS"
};

const initialAuthState = {
    listData: undefined
};

export const reducer = (state = initialAuthState, action) => {
    switch (action.type) {
        case actionTypes.ROLE_ADDED_SUCCESS:
            {
                const {listData} = action.payload;
                return {listData};
            }
        case actionTypes.ROLE_UPDATED_SUCCESS:
            {
                const {listData} = action.payload;
                return {listData};
            }
        default:
            return state;
    }
};

export const actions = {
    roleAdded: ({skip, limit}) => ({
        type: actionTypes.ROLE_ADDED,
        payload: {
            skip,
            limit
        }
    }),
    roleUpdated: ({skip, limit}) => ({
        type: actionTypes.ROLE_UPDATED,
        payload: {
            skip,
            limit
        }
    })
};

export function * saga() {
    yield takeLatest(actionTypes.ROLE_ADDED, function * roleAdded(action) {
        const {skip, limit} = action.payload;
        const listData = yield listRole({skip, limit});

        yield put({type: actionTypes.ROLE_ADDED_SUCCESS, payload: {
                listData
            }});
    });

    yield takeLatest(actionTypes.ROLE_UPDATED, function * roleUpdated(action) {
        const {skip, limit} = action.payload;
        const listData = yield listRole({skip, limit});

        yield put({type: actionTypes.ROLE_UPDATED_SUCCESS, payload: {
                listData
            }});
    });
}
